import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, ReactReduxContext } from 'react-redux';
import TagManager from 'react-gtm-module';

import '@design-system-coopeuch/web/dist/index.css';
import '@design-system-coopeuch/assets/css/custom.css';

// Configuration
import store from './application/config/store';

// Main app
import App from './ui/pages';

const tagManagerArgs = { gtmId: 'GTM-TWWR5NX' };
TagManager.initialize(tagManagerArgs);


ReactDOM.render(
  <Provider store={store} context={ReactReduxContext}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);
